export type IDraggable<T> = T[] & {
    chosen: boolean;
}[]

export function createDraggable<T>(array: T[]): IDraggable<T>  {
    return array.map(val => ({
        ...val,
        chosen: false
    }));
}